import React from 'react';
import accionaLogo from '../assets/Color_Vectorizado 1.png';

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer style={{
      background: '#f7f8fa',
      borderTop: '1px solid #dee2e6',
      boxShadow: '0 -1px 6px rgba(0,0,0,0.06)',
      marginTop: 'auto',
    }}>
      <div style={{ background: '#f7f8fa', padding: '14px 0' }}>
        <div style={{ maxWidth: '95%', margin: '0 auto', padding: '0 1rem' }}>
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            flexWrap: 'wrap',
            gap: '12px',
          }}>

            {/* Left: logo + tagline */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <img
                src={accionaLogo}
                alt="Acciona Logo"
                style={{ height: '22px', width: 'auto', opacity: 0.75 }}
              />
              <span style={{
                color: '#8c96a3',
                fontSize: '12px',
                fontWeight: '500',
                letterSpacing: '0.2px',
              }}>
                Herramienta interna de gestión
              </span>
            </div>

            {/* Center: CTA link */}
            <a
              href="https://www.acciona.com/es/nuestro-proposito/innovacion/digital-hub"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '6px',
                color: '#6c757d',
                fontSize: '12px',
                fontWeight: '500',
                textDecoration: 'none',
                border: 'none',
                borderRadius: '6px',
                padding: '5px 10px',
                background: 'transparent',
                transition: 'all 0.2s ease',
                letterSpacing: '0.1px',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.color = '#2c3e50';
                e.currentTarget.style.background = '#eef0f3';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.color = '#6c757d';
                e.currentTarget.style.background = 'transparent';
              }}
            >
              <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/>
                <polyline points="15 3 21 3 21 9"/>
                <line x1="10" y1="14" x2="21" y2="3"/>
              </svg>
              Conoce el Digital Hub
            </a>

            {/* Right: copyright */}
            <span style={{ color: '#b0b8c4', fontSize: '11px', letterSpacing: '0.2px' }}>
              © {year} ACCIONA · <em style={{ fontStyle: 'normal', color: '#c5cdd6' }}>Business as unusual</em>
            </span>

          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
